export class PromptEmailEvent extends CustomEvent<undefined> {
	static type = 'mist.academy.promptemail';
	constructor() { super(PromptEmailEvent.type); }
}

export class SaveEmailEvent extends CustomEvent<HTMLFormElement> {
	static type = 'mist.academy.saveemail';
	constructor(form: HTMLFormElement) { super(SaveEmailEvent.type, { detail: form }); }
}

export class ResendEmailEvent extends CustomEvent<HTMLFormElement> {
	static type = 'mist.academy.resendemail';
	constructor(form: HTMLFormElement) { super(ResendEmailEvent.type, { detail: form }); }
}

export class CheckEmailEvent extends CustomEvent<HTMLFormElement> {
	static type = 'mist.academy.checkemail';
	constructor(form: HTMLFormElement) { super(CheckEmailEvent.type, { detail: form }); }
}